import { useReadContract } from "wagmi";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import { DisplayValue, Typography } from "../../../../shared";
import { formatUnits } from "viem";

export const DisplayChiPriceTolerance: React.FC = () => {
  const { data: chiPriceTolerance, ...rest } = useReadContract({
    abi: ArbitrageAbi,
    address: contractAddresses.Arbitrage,
    functionName: "chiPriceTolerance",
  });

  return (
    <div className="flex flex-row gap-2">
      <Typography>Chi Price Tolerance:</Typography>
      <DisplayValue
        viewValue={formatUnits(BigInt(chiPriceTolerance || 0), 2)}
        {...rest}
      />
    </div>
  );
};
